import { FieldArray, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Modal, Button, Table, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { feedbackQuestionRes, feedbackQuestionTodo } from '../../LMS_Redux/LMS_Slices/Feedback/FeedbackQuestion'
import { PropagateLoader } from 'react-spinners'
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { addFeedbackRes, addFeedbackTodo } from '../../LMS_Redux/LMS_Slices/Feedback/AddFeedback'
import { toast } from 'react-toastify'

export default function AddFeedback(props) {

    const { feedbackModal, setFeedbackModal, modalLoading, setModalLoading, feedbackModalData, setFeedbackModalData, bool, setBool } = props
    const [breakLoading, setBreakLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const dispatch = useDispatch()
    const question = useSelector(state => state.feedbackQuestion && state.feedbackQuestion.data && state.feedbackQuestion.data.data)
    // console.log(question)

    var rating_data = []
    const rate_data = question && question.filter(val => val.question_type == "rating").map((value) => rating_data.push({
        que_id: value.id,
        rating_ans: '',
        text_ans: '',
        que_object: value
    }))

    var text_data = []
    const txt_data = question && question.filter(val => val.question_type == "text").map((value) => text_data.push({
        que_id: value.id,
        rating_ans: '',
        text_ans: '',
        que_object: value
    }))

    const initialValues = {
        course_id: feedbackModalData && feedbackModalData.course_id,
        training_id: feedbackModalData && feedbackModalData.training_id,
        rating: rating_data,
        text: text_data
    }

    const formik = useFormik({
        initialValues: initialValues,
        // validationSchema: CourseQuizSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true)
            const feed = [...values.rating, ...values.text]
            const finalFeedback = feed.map(({ que_object, ...obj }) => obj)
            dispatch(addFeedbackTodo({ "course_id": values.course_id, "training_id": values.training_id, "feedback_ans": finalFeedback })).then(() => add_res(action))
        },
    })

    const add_res = (action) => {

        if (addFeedbackRes && addFeedbackRes.success) {

            action.resetForm()
            setBool(!bool)
            setSpinner(false)
            setFeedbackModal(false)
            setFeedbackModalData()
            toast.success(addFeedbackRes.message, { position: "bottom-right" })

        } else {
            toast.error(addFeedbackRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }


    const handleClose = () => {
        setFeedbackModal(false)
        setFeedbackModalData()
    }
    const feedback_field_res = () => {
        if (feedbackQuestionRes && feedbackQuestionRes.success) {
            setModalLoading(false)
            setBreakLoading(false)
        } else {
            setBreakLoading(false)
        }
    }

    useEffect(() => {
        if (feedbackModal) {
            setBreakLoading(true)
            dispatch(feedbackQuestionTodo()).then(() => feedback_field_res())
        }
    }, [feedbackModal])

    return (
        <Modal show={feedbackModal} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Feedback</Modal.Title>
            </Modal.Header>

            <FormikProvider value={formik}>
                <form method="post" onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>

                    {
                        modalLoading && breakLoading ?
                            <Modal.Body>
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                            </Modal.Body>

                            :

                            !modalLoading && !breakLoading ?
                                <PerfectScrollbar>
                                    <Modal.Body style={{ height: '60vh' }}>
                                        <FieldArray
                                            name="rating"
                                            render={(arrayHelpers) => (
                                                <>
                                                    <Table bordered size="lg">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr</th>
                                                                <th>Rating Parameter</th>
                                                                <th>5</th>
                                                                <th>4</th>
                                                                <th>3</th>
                                                                <th>2</th>
                                                                <th>1</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formik.values.rating.map((field, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{field.que_object.question}</td>
                                                                    <td>
                                                                        <input className="form-check-input form_checkbox" type="radio" style={{ borderColor: '#9d9d9d' }}
                                                                            name={`rating[${index}].rating_ans`}
                                                                            value={5}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input className="form-check-input form_checkbox" type="radio" style={{ borderColor: '#9d9d9d' }}
                                                                            name={`rating[${index}].rating_ans`}
                                                                            value={4}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input className="form-check-input form_checkbox" type="radio" style={{ borderColor: '#9d9d9d' }}
                                                                            name={`rating[${index}].rating_ans`}
                                                                            value={3}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input className="form-check-input form_checkbox" type="radio" style={{ borderColor: '#9d9d9d' }}
                                                                            name={`rating[${index}].rating_ans`}
                                                                            value={2}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input className="form-check-input form_checkbox" type="radio" style={{ borderColor: '#9d9d9d' }}
                                                                            name={`rating[${index}].rating_ans`}
                                                                            value={1}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>

                                                    </Table>
                                                </>
                                            )}
                                        />

                                        <FieldArray
                                            name="text"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {formik.values.text.map((field, index) => (
                                                        <div key={index} className='mb-2'>
                                                            <label htmlFor="" className="form-label form_label">{field.que_object.question}</label>
                                                            <textarea className="form_input form-control" rows="2"
                                                                name={`text[${index}].text_ans`}
                                                                value={formik.values.text[index].text_ans}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        />
                                    </Modal.Body>
                                </PerfectScrollbar>

                                :

                                modalLoading && !breakLoading ?
                                    <Modal.Body>
                                        <div className='text-center'>
                                            Cannot load Feedback Form
                                        </div>
                                    </Modal.Body>

                                    : ''
                    }

                    <Modal.Footer>
                        <Button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                            {spinner ?
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className='ms-2'
                                />
                                : ''
                            }</Button>

                    </Modal.Footer>

                </form>
            </FormikProvider>

        </Modal>
    )
}
